// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__tMf-p","spin":"Spinner_spin__fs87b"};